export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11571.c2548bee.jpg";